import type { CustomerDetails } from '@entities/customer'

import { useCustomerStore } from '@entities/customer'
import { useCommonStore } from '@shared/model'
import { runApiGet } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'

interface CustomerDetailsApiOptions {
  customerId: string | number
  /** Defaults to the page loader; a flow that owns the loader passes its own. */
  onLoadingChange?: (loading: boolean) => void
}

/** `GET /admin-api/customers/{customer}/details` — General info, Details and Statuses & sources in one read. */
export const useCustomerDetailsApi = async (options: CustomerDetailsApiOptions): Promise<CustomerDetails | null> => {
  const customerStore = useCustomerStore()
  const commonStore = useCommonStore()

  return runApiGet<CustomerDetails>(useAdminRoutes('admin.customer.details-data', { customer_id: options.customerId }), {
    setLoading: options.onLoadingChange ?? commonStore.setLoading,
    handle: (response) => {
      const details: CustomerDetails = response.data
      customerStore.setDetails(details)
      return details
    },
  })
}
